import Tooltip from "@mui/material/Tooltip";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";

const UIIconButton = ({
  title = "",
  loading = false,
  variant = "contained",
  children,
  style = {},
  tooltip = "",
  disabled = false,
  ...rest
}) => {
  return (
    <Tooltip title={tooltip} disableHoverListener={disabled}>
      <span>
        <IconButton
          variant={variant}
          sx={{
            minWidth: "10px",
            textTransform: "none",
            fontSize: "1rem",
            fontWeight: "normal",
            "&:hover": {
              backgroundColor: "var(--palette-secondary_button_hover)",
              color: "var(--palette-secondary_button_text)",
            },
            ...style,
          }}
          disabled={disabled}
          {...rest}
        >
          {children || title}
          {loading && (
            <CircularProgress
              className="text-primary"
              sx={{ ml: 1 }}
              size={18}
            />
          )}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default UIIconButton;
